export const CAMPAIGN_STARTED: string = 'CampaignStarted';
export const CAMPAIGN_DISMISSED: string = 'CampaignDismissed';
export const CAMPAIGN_RENDERED: string = 'CampaignRendered';
export const CAMPAIGN_CLICKED: string = 'CampaignClicked';
export const CAMPAIGN_IMPRESSION: string = 'CampaignImpression';
export const CAMPAIGN_ENDED: string = 'CampaignEnded';
